/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ImageList } from "@mui/material";
import GalleryContext from "components/model-selector/gallery/context";
import SelectGalleryItem from "components/model-selector/gallery/select-gallery-item";

export default function ListGallery () {
    const ctx = useContext(GalleryContext);
    const { models, selectedModel } = ctx;

    return (
        <>
            <ImageList cols={6} rowHeight={100} className='image-selector-image-gallery-frame'>
                {models ? (
                    models.map((model, index) => {
                        const isSelected = model?.guid === selectedModel?.guid;
                        return <SelectGalleryItem model={model} isSelected={isSelected} key={index} />;
                    })
                ) : (
                    <></>
                )}
            </ImageList>
        </>
    );
}
